var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.62467 3.50065V10.209C9.62467 11.4982 8.58051 12.5423 7.29134 12.5423C6.00217 12.5423 4.95801 11.4982 4.95801 10.209V2.91732C4.95801 2.11232 5.61134 1.45898 6.41634 1.45898C7.22134 1.45898 7.87467 2.11232 7.87467 2.91732V9.04232C7.87467 9.36315 7.61217 9.62565 7.29134 9.62565C6.97051 9.62565 6.70801 9.36315 6.70801 9.04232V3.50065H5.83301V9.04232C5.83301 9.84732 6.48634 10.5007 7.29134 10.5007C8.09634 10.5007 8.74967 9.84732 8.74967 9.04232V2.91732C8.74967 1.62815 7.70551 0.583984 6.41634 0.583984C5.12717 0.583984 4.08301 1.62815 4.08301 2.91732V10.209C4.08301 11.9823 5.51801 13.4173 7.29134 13.4173C9.06467 13.4173 10.4997 11.9823 10.4997 10.209V3.50065H9.62467Z",
    fill: "#B6B6B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.f1686246602a2494e03607b44b0fb4dc.svg";
export { ForwardRef as ReactComponent };